import { action, computed, configure, observable } from 'mobx'
import { serializable, identifier, map } from 'serializr'
import HitList from '../../api/HitList'
import { v4 } from 'uuid'

configure({ enforceActions: 'observed' })

class ItemStore {
  itemRequest = 0

  @serializable(identifier())
  _id = v4()

  // The initial list of IDs supplied to the HitList.
  @observable
  ids = []

  // An object containing various data class counts.
  @observable
  counts = observable.map()

  @observable
  items = []

  @serializable(map())
  @observable
  selected = observable.map()

  constructor(ids = [], counts = {}) {
    this.hitListApi = new HitList()
    this.setIds(ids)
    this.setCounts(counts)
  }

  // Setters
  @action
  setIds = (ids = []) => {
    this.ids = ids
  }

  @action
  setCounts = (counts = {}) => this.counts.merge(counts)

  @computed
  get selectedCount() {
    return this.selected.size
  }

  @computed
  get selectedIds() {
    return [...this.selected.keys()]
  }

  // Computed values.
  @computed
  get totalSize() {
    return this.ids.length
  }

  @computed
  get dataClassLabels() {
    let labels = {}
    this.counts.forEach((value, key) => {
      labels[key] = value.label
    })
    return labels
  }

  @action
  selectItem = (id) => this.selected.set(id, null)
  @action
  deSelectItem = (id) => this.selected.delete(id)

  @action
  toggleItem = (id) => {
    if (this.isSelected(id)) {
      this.deSelectItem(id)
    } else {
      this.selectItem(id)
    }
  }

  @action
  selectAll = (ids = []) => {
    // If we are given IDs use those, otherwise use all
    // ids we have in the store.
    const idsToSelect = ids.length === 0 ? this.ids.slice() : ids
    for (const id of idsToSelect) {
      this.selectItem(id)
    }
  }

  @action
  deSelectAll = (ids = []) => {
    const idsToDeSelect = ids.length === 0 ? this.ids.slice() : ids
    for (const id of idsToDeSelect) {
      this.deSelectItem(id)
    }
  }

  isSelected(id) {
    return this.selected.has(id)
  }

  @action
  setItems(items) {
    this.items = items
  }

  @action
  loadItems(
    ids,
    success = (json) => {},
    fail = (err) => {
      console.log(err)
    }
  ) {
    const request = ++this.itemRequest
    return this.hitListApi
      .fetchItems(ids)
      .then((json) => {
        if (request !== this.itemRequest) return
        this.setItems(json.resultset.result)
        return json
      })
      .then((json) => {
        if (request === this.itemRequest) return success(json)
      })
      .catch((err) => {
        if (request === this.itemRequest) return fail(err)
      })
  }
}

export default ItemStore
